var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteTop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000279573 12.4176C0.0694874 12.34 0.149719 12.2721 0.21251 12.1848C3.06949 8.21373 5.92646 4.24263 8.78344 0.271528C8.84274 0.189098 8.90553 0.111521 8.98926 0C8.98926 8.34465 8.98926 16.6505 8.98926 25C5.99275 25 2.99623 25 -0.000278473 25C-0.00027884 20.8059 -0.000279206 16.6117 -0.000279573 12.4176Z",
    fill: "#D9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.9854C20.9965 24.9854 18.014 24.9854 15.007 24.9854C15.007 24.8641 15.007 24.7575 15.007 24.6508C15.007 20.6942 15.007 16.7425 15.014 12.786C15.014 12.626 15.0663 12.4175 15.1465 12.306C18.0419 8.26697 20.9442 4.23283 23.8465 0.198698C23.8884 0.140512 23.9337 0.0871773 24 -9.91821e-05C24 8.3494 24 16.6553 24 24.9854Z",
    fill: "#D9DBE9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white",
    transform: "translate(24 25) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteTop);
export default __webpack_public_path__ + "static/media/quote-top.53cfc6d1cc991c7709522e604c00514d.svg";
export { ForwardRef as ReactComponent };